<template>
  <div
    v-if="!listIsEmpty"
    class="row"
  >
    <div
      class="col-20 mt-4 mb-2 nh-list"
    >
      <div
        key="0"
        class="row table-title-row d-flex justify-content-between"
      >
        <div class="col-2 label">
          {{ $t('view-CampaignsCpcDetails.Members.list.id') }}
        </div>
        <div class="col-8 label">
          {{ $t('view-CampaignsCpcDetails.Members.list.name') }}
        </div>
        <div class="col-7 label">
          {{ $t('view-CampaignsCpcDetails.Members.list.link') }}
        </div>
        <div class="col-3 label">
          {{ $t('view-CampaignsCpcDetails.Members.list.clicks') }}
        </div>
      </div>
      <transition-group
        name="fade"
        tag="div"
        class="table-content"
      >
        <member-entry
          v-for="member in members"
          :key="member.id"
          :campaign="campaign"
          :member="member"
          :report="reportMember(member)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import '../../../assets/scss/nh-list.scss'
import MemberEntry from './MemberEntry.vue'

export default {
  components: {
    'member-entry': MemberEntry
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    members: {
      type: Array,
      default: () => { return null }
    },
    report: {
      type: Object,
      default: () => { return null }
    }
  },
  data () {
    return {
      loader: true
    }
  },
  computed: {
    listIsEmpty () {
      return this.members.length === 0
    }
  },
  methods: {
    avatar (member) {
      return this.$store.getters['user/getAvatar'](member.influencerData)
    },
    reportMember (member) {
      return this.report.per_member[member.id] || null
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
